import * as o from "react";
import a from "../lib/IconBase.es.js";
import c from "../defs/Folder.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: c }));
e.displayName = "FolderIcon";
const n = e;
export {
  n as Folder,
  e as FolderIcon,
  e as FolderNotchIcon
};
